<template lang="pug">
  v-btn(
    v-if="showButton"
    class="secondary-button text-btn"
    @click="handlePremium"
    data-test="billing-activation-button"
    :loading="trialLoading"
  )
    e-svg-icon(class="mr-2") flash-primary
    span {{ buttonText }}
</template>

<script>
import { mapGetters } from 'vuex'
import premiumPlan from '~/mixins/plans/premiumPlan'
import contentDialog from '~/mixins/dialogs/contentDialog'
import premiumTrial from '~/modules/onboarding/mixins/premiumTrial'

export default {
  name: 'BillingActivationButton',
  mixins: [premiumPlan, contentDialog, premiumTrial],
  computed: {
    ...mapGetters('organizations', {
      organizations: 'items'
    }),
    showButton() {
      return !this.$hasProVersion || this.isLessThanOr10DaysOfPremium
    },
    daysLeft() {
      if (this.$hasProVersion && this.$Organization.availableUntil) {
        const availableUntil = this.$moment(this.$Organization.availableUntil)
        const today = this.$moment()
        return availableUntil.diff(today, 'days') + 1 // add 1 to include today
      }
      return null
    },
    isLessThanOr10DaysOfPremium() {
      return this.daysLeft > 0 && this.daysLeft <= 10
    },
    buttonText() {
      if (this.isLessThanOr10DaysOfPremium) {
        let key
        if (this.daysLeft === 1) {
          key = 'leftDays_one'
        } else if ([2, 3, 4].includes(this.daysLeft)) {
          key = 'leftDays_few'
        } else {
          key = 'leftDays_many'
        }
        return this.$t(key, { count: this.daysLeft })
      }
      return this.$t('Active premium')
    }
  },
  methods: {
    async handlePremium() {
      if (!this.$Organization || !this.organizations.length) {
        this.showPremiumFeaturesModal()
      } else if (this.$Organization && this.$Organization?.canActivateTrial) {
        await this.activatePremiumTrial()
      } else {
        this.$router.push({ name: 'billing' })
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
